import TYPES from '../types'

export const rpanelState = {
  curTab: '',
}


export const rpanelMutations = {
  [TYPES.CHANGE_RIGHT_TAB](state, key) {
    state.rpanelState.curTab = key
  },
}
